var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 265,
    viewBox: "0 0 212 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M91.2478 39.6603C125.813 -42.2815 41.207 22.0428 0.518122 60.7174C-0.287598 81.9683 -0.750888 119.998 3.84172 102.111C9.58248 79.7525 89.1328 -27.416 74.3277 49.3289C59.5226 126.074 35.351 157.706 25.6823 128.096C16.0137 98.4855 58.0119 58.3932 49.5518 70.479C41.0917 82.5648 29.2219 116.916 33.1498 128.096C37.0777 139.275 73.3351 28.69 62.76 35.0351C52.1849 41.3801 -6.43122 88.5147 20.1576 142.599C46.7463 196.683 48.0411 142.087 91.2478 39.6603Z",
    fill: "url(#paint0_linear_18_24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 6",
    filter: "url(#filter0_i_18_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3539 129.807C39.6152 119.412 49.6659 116.363 61.5068 129.807L74.7245 178.036L74.7245 232.918C54.3472 209.774 9.34725 157.496 31.3539 129.807Z",
    fill: "#5B6472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 7",
    filter: "url(#filter1_i_18_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.101 129.807C171.84 119.412 161.789 116.363 149.948 129.807L136.73 178.036L136.73 232.918C157.107 209.774 202.107 157.496 180.101 129.807Z",
    fill: "#5B6472"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M200.021 133.452C233.861 170.435 184.007 239.505 140.196 215.334C103.637 206.874 140.196 116.834 138.383 135.87C136.57 154.905 129.621 212.312 178.569 187.536C227.516 162.76 196.093 137.985 173.432 124.388C150.771 110.792 155.303 141.308 161.951 137.985C168.598 134.661 208.095 145.84 193.374 153.092C178.652 160.343 147.448 183.608 147.448 145.84C147.448 108.072 157.721 87.2241 200.021 133.452Z",
    fill: "url(#paint1_linear_18_24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M60.9908 213.514C68.2993 213.963 75.5528 214.058 81.8813 213.919C122.671 210.293 135.965 197.905 108.47 228.12C90.8795 247.45 74.5256 230.792 60.9908 213.514C31.3131 211.689 0.729683 204.024 27.4952 182.496C69.1912 148.958 72.817 152.583 77.3492 171.316C81.8813 190.049 75.2341 204.25 63.7526 200.624C52.2711 196.999 58.9183 177.359 56.5011 178.87C54.084 180.381 66.4719 167.086 67.6805 178.87C68.8891 190.654 80.0685 168.295 71.9105 167.086C63.7526 165.878 25.6823 179.474 41.0917 190.049C46.6427 193.859 53.3699 203.785 60.9908 213.514Z",
    fill: "url(#paint2_linear_18_24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M135.14 223.764C135.14 246.101 94.4943 198.117 127.675 264.716C107.352 261.82 77.9043 245.399 77.9043 220.041C77.9043 194.682 89.1026 182.811 103.204 173.297C128.504 180.33 135.14 193.567 135.14 223.764Z",
    fill: "url(#paint3_linear_18_24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M77.9043 196.351L79.9806 190.786H131.059L133.55 196.351H77.9043Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3",
    filter: "url(#filter2_i_18_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.509 68.8121C159.068 133.958 131.227 193.586 131.227 190.684C122.911 190.684 87.5713 190.684 80.0875 190.684C80.0875 193.172 51.3996 132.236 57.2204 67.983C60.5866 30.8264 95.5318 0.484253 107.173 0.484253C118.814 0.484253 151.805 30.1686 154.509 68.8121Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4",
    filter: "url(#filter3_d_18_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.702 169.075C109.702 206.009 107.715 228.418 105.642 240.867C103.74 228.418 100.958 203.683 100.958 169.075C100.958 134.467 101.582 118.446 105.642 118.446C109.702 118.446 109.702 134.467 109.702 169.075Z",
    fill: "#4B5563"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 106.183,
    cy: 74.6347,
    r: 26.6942,
    fill: "#5B6472"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6",
    filter: "url(#filter4_i_18_24)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.183,
    cy: 75.2279,
    rx: 23.1349,
    ry: 22.5417,
    fill: "#CBF1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18_24",
    x: 25.4381,
    y: 120.831,
    width: 49.2865,
    height: 116.087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18_24",
    x: 136.73,
    y: 120.831,
    width: 49.2864,
    height: 116.087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_18_24",
    x: 56.4409,
    y: 0.484253,
    width: 98.5729,
    height: 209.302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_24"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_18_24",
    x: 91.0576,
    y: 112.546,
    width: 28.5444,
    height: 142.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_24",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_18_24",
    x: 83.0485,
    y: 48.6862,
    width: 46.2699,
    height: 49.0834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_24",
    x1: 75.2341,
    y1: 94.9528,
    x2: 20.5459,
    y2: 81.9606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676B71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_24",
    x1: 167.53,
    y1: 106.959,
    x2: 167.389,
    y2: 212.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BACBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67717F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_24",
    x1: 67.4346,
    y1: 157.201,
    x2: 67.4346,
    y2: 213.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697382",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_24",
    x1: 106.522,
    y1: 173.297,
    x2: 106.522,
    y2: 248.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B7D99",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon 5.b713f4d9a628a395b3803e01b0fb41fd.svg";
export { ForwardRef as ReactComponent };